
import * as React from "react";
import { styled } from "@mui/material/styles";
import TableContainer from "@mui/material/TableContainer";
import { Paper, } from "@mui/material";
import 'react-phone-input-2/lib/style.css';
import { useState, useEffect } from "react";
import { APIPath, token } from "../../config/api";
import { current } from "@reduxjs/toolkit";
import "./Currency.css";

const StyledTableContainer = styled(TableContainer)(({ theme, open }) => ({
    width: open ? "80%" : "94%",
    transition: "width 0.3s ease",
    paddingTop: "7px",
    marginLeft: open ? "243px" : "69px",
    position: "relative",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    overflow: "hidden",
    marginBottom: "20px",
    boxShadow: "none",
}));

const AddCurrency = ({ open, onClose, getCurrencyList,editaedCurrency }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [country, setCountry] = useState(null)
    const [countryName, setCountryName] = useState("");
    const [countryId, setCountryId] = useState("");
    const [currencyName,setCurrencyName]=useState("" );
    const [currencyValue,setCurrencyValue]=useState("");
    const [markupValue,setMarkupValue]=useState("");

    useEffect(() => {
        if(editaedCurrency) {
            setCurrencyName(editaedCurrency.code);
            setCurrencyValue(editaedCurrency.rate);
            setMarkupValue(editaedCurrency.markupValue);
        }
    }, [editaedCurrency])

    useEffect(() => {
        fetch(`${APIPath}/api/v1/agency/country`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: 'GET',
            mode: 'cors',
        })
            .then((res) => res.json())
            .then((data) => {
                setCountry(data.data);
            })
            .catch((err) => {
                alert(err)
            })
    }, [])


    const AddNewCurrency = () => {
        setIsLoading(true);
        const method = editaedCurrency ? 'PATCH' : 'POST';
        const url = editaedCurrency ? `${APIPath}/api/v1/agency/currency/${editaedCurrency._id}` : `${APIPath}/api/v1/agency/currency`;
        fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            method: method,
            mode: 'cors',
            body:JSON.stringify({
                "code": currencyName,
                "rate": currencyValue,
                "markupValue": markupValue,
            })
        })
            .then((res) => res.json())
            .then((data) => {
                if(data.statusCode === 400) {
                    alert("Currency already exists!!");
                    setIsLoading(false);
                    return;
                }
                else {
                    setIsLoading(false);
                    onClose();
                    getCurrencyList();
                }
            })
            .catch((err) => {
                alert(err)
            })
    }

    const Uppercase = (str) => str?.toUpperCase();
    const capitalize = (str) => {
        if (typeof str !== 'string') return '';
        return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
    };
    return (
        <StyledTableContainer component={Paper} open={open}>
            <div className="add-country-container">
                <div className="add-country-form">
                    <form className="add-country" onSubmit={(e) => {
                        e.preventDefault();
                        AddNewCurrency();
                    }}>
                        {editaedCurrency ? <h2>Edit Currency</h2> : <h2>Add New Currency</h2>}
                        {/* <div className="add-country-name" style={{ width: "100%",marginBottom:"10px" }}>
                            <label>Select country *</label>
                            <select value={countryId} onChange={(e) => setCountryId(e.target.value)}
                                required
                            >
                                <option value="" disabled>Select Country</option>
                                {country?.map((country, id) => (
                                    <option key={country._id} value={country._id}>
                                        {Uppercase(country.name)}
                                    </option>
                                ))}
                            </select>
                        </div> */}

                        <div className="add-country-name">
                            <label>Currency Name *</label>
                            <input
                                type="text"
                                placeholder="Type Currency name..."
                                name="name"
                                value={currencyName}
                                maxLength={40}
                                onChange={(e) => {
                                    setCurrencyName(e.target.value);
                                }}
                                required
                            />
                        </div>
                        <div className="add-country-name">
                            <label>Currency Value *</label>
                            <input
                                type="text"
                                placeholder="Enter Currency Value..."
                                name="currencyValue"
                                value={currencyValue}
                                maxLength={40}
                                onChange={(e) => {
                                    setCurrencyValue(e.target.value);
                                }}
                                required
                            />
                        </div>

                        <div className="add-country-name">
                            <label>Markup Value *</label>
                            <input
                                type="text"
                                placeholder="Enter Markup Value..."
                                name="markupValue"
                                value={markupValue}
                                maxLength={40}
                                onChange={(e) => {
                                    setMarkupValue(e.target.value);
                                }}
                                required
                            />
                        </div>
                        <div className="add-country-btn">
                            {isLoading ? (
                                <div className="loader"></div>
                            ) : (
                                <>
                                    <button onClick={onClose} id="cancel">Cancel</button>
                                    <button type="submit" id="addvehicle" >
                                        {editaedCurrency ? "Update Currency" : "Add Currency"}
                                    </button>
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </StyledTableContainer>

    );
}

export default AddCurrency;
